import { useWindowSize } from "react-use"
export default function useMapDimensions() {
  const windowSize = useWindowSize()
  const stackMaps = windowSize.width < 768
  const headerHeight = 96
  const mapWidth =  stackMaps ? windowSize.width : windowSize.width / 2
  const mapHeight = stackMaps ? windowSize.height * 0.45 : windowSize.height - headerHeight - 5

  return { mapWidth, mapHeight, stackMaps }
}
